import {HttpClient} from './HttpClient';
import {API_URL, API_KEY} from '../config/index';

export class Movie {
  private httpClient: HttpClient;

  constructor() {
     this.httpClient = new HttpClient({
       config: {
        baseURL: API_URL,
       }
     });
  }

  public getLatestMovie = () => {
    return this.httpClient.get(`/3/movie/latest?api_key=${API_KEY}`)
  }

  public getPopularMovies = () => {
    return this.httpClient.get(`/3/movie/popular?api_key=${API_KEY}`)
  }

  public getTrendingMovies = (range:string, page: number) => {
    return this.httpClient.get(`/3/trending/movie/${range}?api_key=${API_KEY}&page=${page}`)
  }

   public getSimilarMovies = (id:number) => {
    return this.httpClient.get(`/3/movie/${id}/similar?api_key=${API_KEY}`)
  }

  public getVideosForMovie = (id:number) => {
    return this.httpClient.get(`/3/movie/${id}/videos?api_key=${API_KEY}`)
  }

  public getUpcomingMovies = () => {
    return this.httpClient.get(`/3/movie/popular?api_key=${API_KEY}`)
  }

  public getMovieById = (id:number) => {
    return this.httpClient.get(`/3/movie/${id}?api_key=${API_KEY}`)
  }

  public getCategories = () => {
    return this.httpClient.get(`/3/genre/movie/list?api_key=${API_KEY}`)
  }

  public searchMovies = (query:string) => {
    return this.httpClient.get(`/3/search/movie?api_key=${API_KEY}&query=${query}`)
  }
}